module.exports = __webpack_public_path__ + "img/Shahi.e79c0c3d.png";